import { Navigate, Outlet } from 'react-router-dom'
import { useSession } from '../store/session'
import { ForcePasswordChange } from './ForcePasswordChange'

export function RequireAuth() {
  const { status, me } = useSession()

  if (status === 'loading') {
    return (
      <div className="auth-wrap">
        <div className="skeleton" style={{ width: 220, height: 14 }} />
      </div>
    )
  }
  if (status === 'anon' || !me) return <Navigate to="/login" replace />
  if (me.must_change_password) return <ForcePasswordChange />
  return <Outlet />
}
